import { Suspense, useEffect, useState } from "react";
import { Grid, Layout, notification } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import HeaderComponent from "./components/HeaderComponent";
import SidebarComponent from "./components/SidebarComponent";
import { CONSTANT } from "../../../config/Constant";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshTokenApi,
  setIsRefreshingToken,
  setIsUnauthorise,
} from "../../../features/auth/authSlice";
import { processFailedApiQueue } from "../../../features/auth/interceptorSlice";
import { resetStore } from "../../../features/auth/apiService";
import RestrictedAccessPage from "../../../components/RestrictedAccessPage";
import PageSpinner from "../../../components/PageSpinner/PageSpinner";
import { OverlayProvider } from "../../../context/OverlayContext";
import OverlayManager from "../../../components/OverlayManager";

const MainLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const { token, isUnauthorise, isRestricted, isAppReady } = useSelector(
    (state) => state.auth,
  );
  const isTenantVerified = localStorage.getItem("isTenantVerified") || "false";
  const isAdmin = localStorage.getItem("isa") || "false";

  const [collapsed, setCollapsed] = useState(isMobile);
  const [siderWidth, setSiderWidth] = useState(250);

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isMobile]);

  useEffect(() => {
    if (!isAppReady) return;

    if (!token) {
      navigate(CONSTANT.LOGIN_REDIRECT_PATH);
    }
    if (token && isTenantVerified === "false") {
      navigate(CONSTANT.ROUTE.ONBOARDING);
    }
  }, [token, navigate, isAppReady, isTenantVerified]);

  useEffect(() => {
    if (isUnauthorise === true) {
      dispatch(refreshTokenApi())
        .unwrap()
        .then((token) => {
          processFailedApiQueue(token);
          dispatch(setIsUnauthorise(false));
          dispatch(setIsRefreshingToken(false));
        })
        .catch((err) => {
          resetStore();
        });
    }
  }, [isUnauthorise, dispatch, isTenantVerified, navigate]);

  useEffect(() => {
    if (!isMobile) return;

    const vv = window.visualViewport;

    const update = () => {
      notification.config({
        top: 20 + vv.offsetTop || 0,
      });
    };

    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);

    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <OverlayProvider>
      <Layout className={`main__page__content`}>
        <Layout.Header>
          <HeaderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
        </Layout.Header>
        <Layout className="site-layout">
          {(isAdmin === "true" || isTenantVerified === "true") && (
            <SidebarComponent
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              siderWidth={siderWidth}
              setSiderWidth={setSiderWidth}
            />
          )}

          <Layout.Content className="main__app__content">
            {isRestricted ? (
              <RestrictedAccessPage />
            ) : (
              <Suspense fallback={<PageSpinner size="large" fullPage={true} />}>
                <Outlet />
              </Suspense>
            )}
          </Layout.Content>
        </Layout>
        <OverlayManager />
      </Layout>
    </OverlayProvider>
  );
};

export default MainLayout;
